// Mock data for Ganetov Premium Puter
// You can easily edit prices and product details here

export const products = [
  {
    id: "gpp-50g",
    name: "Ganetov Premium Puter od Kikirikija",
    size: "50g",
    price: 350,
    description: "Idealan za degustaciju ili poklon",
    image: "https://images.unsplash.com/photo-1624684244440-1130c3b65783?w=400&q=80"
  },
  {
    id: "gpp-350g",
    name: "Ganetov Premium Puter od Kikirikija",
    size: "350g",
    price: 890,
    description: "Savršena veličina za svakodnevnu upotrebu",
    image: "https://images.unsplash.com/photo-1624684244440-1130c3b65783?w=400&q=80"
  },
  {
    id: "gpp-700g",
    name: "Ganetov Premium Puter od Kikirikija",
    size: "700g",
    price: 1490,
    description: "Porodična veličina za ljubitelje putera",
    image: "https://images.unsplash.com/photo-1624684244440-1130c3b65783?w=400&q=80"
  },
  {
    id: "gpp-2kg",
    name: "Ganetov Premium Puter od Kikirikija",
    size: "2kg",
    price: 3490,
    description: "Profesionalna veličina za prave gurmane",
    image: "https://images.unsplash.com/photo-1624684244440-1130c3b65783?w=400&q=80"
  }
];

export const promoCode = {
  code: "PREMIUM10",
  discount: 10,
  message: "POKLON DOBRODOŠLICE -10% PRI PRVOJ PORUDŽBINI | Kod na kasi: PREMIUM10"
};

// Shipping settings
export const shippingSettings = {
  shippingCost: 350,
  freeShippingThreshold: 4000,
  pickupLocations: [
    { id: 'novi-sad', name: 'Novi Sad' },
    { id: 'pancevo', name: 'Pančevo' }
  ]
};

export const brandInfo = {
  name: "Ganetov Premium Puter",
  tagline: "",
  company: "Gane&M Company",
  address: "Omladinskih Radnih Akcija 28",
  city: "21000 Novi Sad, Srbija",
  email: "office.ganemcompany@gmail.com",
  orderEmail: "ganetovpremiumputer@gmail.com",
  phones: ["+381 60 488 97 21", "+381 63 173 75 19"],
  instagram: "https://www.instagram.com/premiumputer/",
  copyright: "©2025 Ganetov Puter. Sva prava zadržana."
};

export const processValues = [
  {
    id: 1,
    title: "Stroga kontrola kvaliteta",
    description: "Svako zrno prolazi rigoroznu proveru pre prerade"
  },
  {
    id: 2,
    title: "Jedinstvena receptura",
    description: "Tajna formula za savršen ukus i teksturu"
  },
  {
    id: 3,
    title: "Očuvanje nutritivne vrednosti",
    description: "Minimalna obrada za maksimalnu hranljivost"
  },
  {
    id: 4,
    title: "Najfinija kremasta tekstura",
    description: "Svilenkasta glatkoća u svakom zalogaju"
  },
  {
    id: 5,
    title: "Neponovljivo bogatstvo ukusa",
    description: "Dubina arome koja osvaja čula"
  },
  {
    id: 6,
    title: "Zdrava energija svaki dan",
    description: "Prirodni izvor proteina i zdravih masti"
  }
];

export const navigationLinks = [
  { name: "Naša priča", href: "#story" },
  { name: "Proizvodi", href: "#products" },
  { name: "Premium užitak", href: "#premium" },
  { name: "Kontakt", href: "#contact" }
];

export const footerLinks = [
  { name: "Naša priča", href: "#story" },
  { name: "Proizvodi", href: "#products" },
  { name: "Premium užitak", href: "#premium" },
  { name: "Kontakt", href: "#contact" },
  { name: "FAQ", href: "#faq" }
];

export const faqData = [
  {
    question: "Od čega je napravljen Ganetov Premium Puter?",
    answer: "Naš puter je napravljen od 100% prirodnih sastojaka, bez dodatih šećera, aditiva, industrijskih stabilizatora i konzervansa. Koristimo brazilski, blanširani kikiriki vrhunskog kvaliteta."
  },
  {
    question: "Koliko dugo traje proizvod nakon otvaranja?",
    answer: "Rok upotrebe je godinu dana. Nakon otvaranja, preporučujemo da se proizvod potroši u roku od 3 meseca. Čuvajte na suvom i tamnom mestu, maksimalna temperatura do 25°."
  },
  {
    question: "Da li je proizvod bez glutena?",
    answer: "Da, naš kikiriki puter je prirodno bez glutena i siguran je za osobe sa celijakijom ili intolerancijom na gluten."
  },
  {
    question: "Kako mogu da naručim?",
    answer: "Jednostavno dodajte željene proizvode u korpu, unesite podatke za dostavu i potvrdite porudžbinu. Plaćanje je pouzećem prilikom preuzimanja paketa."
  },
  {
    question: "Za koliko dana stiže porudžbina?",
    answer: "Porudžbine se obrađuju u roku od 24h, a dostava traje 1-3 radna dana u zavisnosti od lokacije."
  }
];
